// categoryConstants.js
'use strict';
import {
  CATEGORY_FEED_STORY,
  CATEGORY_FEED_POST_VIDEO,
  CATEGORY_FEED_SHORT,
  CATEGORY_FEED_POST_IMAGE,
} from '../RemoteConfigKeys.js';

export const CategoryListType = Object.freeze({
  ALL: 'all',
  STORY: 'story',
  FLIX: 'flix',
  SHORT: 'short',
  IMAGE: 'image',
});

export const CategoryI18nKey = {
  [CategoryListType.STORY]: 'story',
  [CategoryListType.FLIX]: 'video',
  [CategoryListType.SHORT]: 'short',
  [CategoryListType.IMAGE]: 'image',
};

export const CATEGORY_FEED_REMOTE_CONFIG_KEYS = {
  [CategoryListType.STORY]: CATEGORY_FEED_STORY,
  [CategoryListType.FLIX]: CATEGORY_FEED_POST_VIDEO,
  [CategoryListType.SHORT]: CATEGORY_FEED_SHORT,
  [CategoryListType.IMAGE]: CATEGORY_FEED_POST_IMAGE,
};
